module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('m-panel', {
    attrs: {
      "title": "用户评价",
      "messagePanel": _vm.messagePanel
    }
  }, [(_vm.isWkbFlag) ? _c('ul', _vm._l((_vm.messages), function(message) {
    return _c('li', [_c('div', {
      staticClass: "comments_ul_user"
    }, [_c('img', {
      staticClass: "comments_ul_user_avatar",
      attrs: {
        "src": message.utTdavatar
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "comments_ul_user_info"
    }, [_c('span', [_vm._v(_vm._s(message.utTdnick))]), _vm._v(" "), _c('label', {
      staticClass: "comments_ul_time"
    }, [_vm._v(_vm._s(message.createTime))])]), _vm._v(" "), _c('div', {
      staticClass: "comments_ul__star"
    }, [_c('img', {
      staticClass: "img",
      attrs: {
        "src": _vm._f("scoreImg")(message.score, 1),
        "alt": "",
        "data-star": "1"
      }
    }), _vm._v(" "), _c('img', {
      staticClass: "img",
      attrs: {
        "src": _vm._f("scoreImg")(message.score, 2),
        "alt": "",
        "data-star": "2"
      }
    }), _vm._v(" "), _c('img', {
      staticClass: "img",
      attrs: {
        "src": _vm._f("scoreImg")(message.score, 3),
        "alt": "",
        "data-star": "3"
      }
    }), _vm._v(" "), _c('img', {
      staticClass: "img",
      attrs: {
        "src": _vm._f("scoreImg")(message.score, 4),
        "alt": "",
        "data-star": "4"
      }
    }), _vm._v(" "), _c('img', {
      staticClass: "img",
      attrs: {
        "src": _vm._f("scoreImg")(message.score, 5),
        "alt": "",
        "data-star": "5"
      }
    })]), _vm._v(" "), _c('label', {
      staticClass: "comments_ul__star_msg"
    }, [_vm._v(_vm._s(_vm._f("scoreMsg")(message.score)))])]), _vm._v(" "), _c('p', {
      staticClass: "comments_ul_notes"
    }, [_vm._v(_vm._s(message.ptNotes))]), _vm._v(" "), _c('div', {
      staticClass: "comments_ul_product"
    }, [_c('label', {
      staticClass: "comments_ul_time"
    }, [_vm._v(_vm._s(message.productInfo))]), _vm._v(" "), _c('div', {
      staticClass: "comments_ul_quality"
    }, [(message.isQuality) ? _c('img', {
      attrs: {
        "src": "static/common/images/quality.png",
        "alt": ""
      }
    }) : _vm._e()])]), _vm._v(" "), (message.reply != null && message.reply != '') ? _c('p', {
      staticClass: "comments_ul_reply"
    }, [_c('span', {
      staticClass: "comments_ul_reply_triangle"
    }), _c('label', [_vm._v("悟空保客服回复：")]), _vm._v(_vm._s(message.reply))]) : _vm._e()])
  })) : _c('ul', _vm._l((_vm.messages), function(message) {
    return _c('li', [_c('div', {
      staticClass: "title"
    }, [_c('span', {
      staticClass: "user"
    }, [_vm._v(_vm._s(message.user))]), _vm._v(" "), _c('span', {
      staticClass: "date"
    }, [_vm._v(_vm._s(message.date))])]), _vm._v(" "), _c('p', {
      staticClass: "message"
    }, [_vm._v(_vm._s(message.message))])])
  }))]), _vm._v(" "), (_vm.allMessages.length > 4) ? _c('div', {
    staticClass: "footer theme-color"
  }, [_c('span', {
    staticClass: "more",
    class: {
      'more--active': !_vm.showMoreState
    },
    on: {
      "click": _vm.showMore
    }
  }, [_vm._v(_vm._s(_vm.moreTips))])]) : _vm._e(), _vm._v(" "), (_vm.isShowMore) ? _c('div', {
    staticClass: "footer theme-color"
  }, [_c('span', {
    staticClass: "goMore",
    class: _vm.goMoreClass,
    on: {
      "click": _vm.goMore
    }
  }, [_vm._v("查看更多(" + _vm._s(_vm.totalNumber) + ")")])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c416c6e8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Message.vue
// module id = 691
// module chunks = 1